import { FlexColumn } from '@gorila-shared-ui/components';
import { toaster } from 'baseui/toast';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { useStyles } from './useStyles';

export function useToast() {
  const { theme } = useStyles();

  const showInfoToast = (text: string) => {
    return toaster.info(text);
  };
  const showPositiveToast = (text: string) => {
    return toaster.positive(text);
  };
  const showWarningToast = (text: string) => {
    return toaster.warning(text);
  };
  const showNegativeToast = (text: string) => {
    return toaster.negative(text);
  };

  const showNotification = (title: string, content: string) => {
    return toaster.warning(
      <FlexColumn gap={theme.sizing.scale200}>
        <LabelSmall
          color={theme.colors.contentInversePrimary}
          style={{
            fontWeight: theme.typography.HeadingXSmall.fontWeight,
          }}
        >
          {title}
        </LabelSmall>
        <ParagraphSmall
          color={theme.colors.contentInversePrimary}
          margin={0}
        >
          {content}
        </ParagraphSmall>
      </FlexColumn>,
      {
        overrides: {
          Body: {
            style: {
              backgroundColor: theme.colors.backgroundInverseSecondary,
              color: theme.colors.contentInversePrimary,
            },
          },
        },
      }
    );
  };

  return {
    showInfoToast,
    showPositiveToast,
    showWarningToast,
    showNegativeToast,
    showNotification,
  };
}
